module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-35.a077bd3c.png";